import { setYupItalianValidationLocale } from '@framework/validation/italianValidationLocale.ts';

setYupItalianValidationLocale();
